import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const ExpandableInfoCard = ({ title = "What is this data?", children }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div className="border border-slate-200 rounded-lg overflow-hidden bg-white shadow-sm">
            <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="w-full px-4 py-3 flex items-center justify-between bg-slate-50 hover:bg-slate-100 transition-colors duration-200 text-left"
            >
                <span className="font-medium text-slate-700">{title}</span>
                <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`w-4 h-4 text-slate-500 transform transition-transform duration-200 ${
                        isExpanded ? 'rotate-180' : ''
                    }`}
                />
            </button>
            <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    isExpanded ? 'max-h-[600px]' : 'max-h-0'
                }`}
            >
                <div className="px-4 py-3 space-y-3 text-slate-600 text-sm leading-relaxed border-t border-slate-100">
                    {children}
                </div>
            </div>
        </div>
    );
};

export const ExpandableInfoCardDescription = ({ children }) => {
    return <p>{children}</p>;
};

export const ExpandableInfoCardDetail = ({ name, children }) => {
    return (
        <div>
            <h4 className="font-medium text-slate-700 mb-1">{name}</h4>
            <p className="text-xs">
                {children}
            </p>
        </div>
    );
};

export default ExpandableInfoCard;